// extracted by mini-css-extract-plugin
export default {"btn":"SuggestionItem__btn--1GK","active":"SuggestionItem__active--2g6","highlighted":"SuggestionItem__highlighted--Zs4"};